import { render, staticRenderFns } from "./SelectedFilters.vue?vue&type=template&id=0fbf7942&scoped=true&lang=pug&"
import script from "./SelectedFilters.vue?vue&type=script&setup=true&lang=js&"
export * from "./SelectedFilters.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SelectedFilters.vue?vue&type=style&index=0&id=0fbf7942&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbf7942",
  null
  
)

export default component.exports